<template>
  <v-container grid-list-md>
    <v-layout row wrap align-center>
      <v-flex>
        <v-text-field
          v-model="filters.search"
          label="Buscar"
          prepend-inner-icon="mdi-magnify"
          solo
          single-line
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex style="flex: 0 auto">
        <v-btn color="primary" append to="criar" large>Novo cardapio</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex class="md1">
        <v-text-field v-model="filters.ano" label="Ano"></v-text-field>
      </v-flex>
      <v-flex class="md6">
        <v-select
          v-model="filters.idTurma"
          :items="turmas ? turmas : []"
          label="Turma"
          :item-text="turmas_format"
          item-value="id"
        ></v-select>
      </v-flex>
      <v-flex class="md4">
        <v-select
          v-model="filters.status"
          :items="situacao"
          label="Situação"
          item-text="nome"
          item-value="cod"
        ></v-select>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex class="md1 mt-3">
        <v-btn color="primary" @click="limpar">Limpar</v-btn>
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <v-flex md12>
        <v-data-table
          :headers="headers"
          :items="cardapios.data"
          :search="filters.search"
          :options.sync="options"
          class="elevation-2"
          no-data-text="Não há cardapios disponíveis"
          no-results-text="Nenhum cardapio encontrado"
          :loading="table_load"
          :server-items-length="pagination.total"
          :footer-props="{ 'items-per-page-options': [5, 10, 20, 50] }"
        >
          <template #body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td
                  style="cursor:pointer"
                  @click="$router.push(`refeicoes/${item.id}`)"
                >
                  {{ item.titulo }}
                </td>
                <td>
                  <v-chip
                    small
                    v-for="{ id, serie, nome } in item.turma.slice(0, 1)"
                    :key="id"
                  >
                    {{ [serie.nome, nome, serie.nivel.nome].join(' ') }}
                  </v-chip>
                  <v-tooltip top v-if="item.turma.length > 1">
                    <template #activator="{ on }">
                      <v-chip small v-on="on"
                        >+ {{ item.turma.length - 1 }} outras</v-chip
                      >
                    </template>
                    <span>
                      {{
                        item.turma
                          .slice(1)
                          .map(t =>
                            [t.serie.nome, t.nome, t.serie.nivel.nome].join(' ')
                          )
                          .join('; ')
                      }}
                    </span>
                  </v-tooltip>
                </td>
                <td>
                  <v-chip v-if="item.desativar === 'N'" avatar small>
                    <v-icon left small>mdi-eye</v-icon>
                    <span>Ativo</span>
                  </v-chip>
                  <v-chip
                    v-if="item.desativar === 'S'"
                    dark
                    avatar
                    small
                    class="mb-2"
                  >
                    <v-icon left small>mdi-eye-off</v-icon>
                    <span>Desativado</span>
                  </v-chip>
                </td>
                <td>
                  <v-btn icon append :to="item.id">
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                  <v-btn icon append :to="`${item.id}/editar`">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>

                  <!-- <v-btn icon @click.stop="$refs.delete.request(item.id)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn> -->
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <confirm ref="delete" :confirm-fn="remove"
          >Deseja excluir este cardapio?</confirm
        >
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { Cardapio, Turma } from '../../service'
import Confirm from '../../components/Confirm'

export default {
  components: { Confirm },
  data() {
    return {
      cardapios: [],
      items: [],
      headers: [
        {
          text: 'Titulo',
          value: 'titulo'
        },
        {
          text: 'Turma',
          value: 'turma.nome',
          sortable: false
        },
        {
          text: 'Status',
          value: 'status'
        },
        { text: 'Ação', value: 'name', sortable: false }
      ],
      filters: {
        search: '',
        // start_date: '',
        // end_date: '',
        // inicio: null,
        // fim: null,
        idTurma: null,
        status: null,
        ano: new Date().getFullYear()
      },
      situacao: [
        { cod: 'P', nome: 'Pendente' },
        { cod: 'A', nome: 'Agendado' },
        { cod: 'E', nome: 'Publicado' },
        { cod: 'C', nome: 'Cadastrado' },
        { cod: 'D', nome: 'Desativado' },
        { cod: 'R', nome: 'Reprovado' }
      ],
      turmas: [],
      options: {},
      delay: 500,
      //   show_start_date: false,
      //   start_date: null,
      //   show_end_date: false,
      //   end_date: null,
      status: null,
      expand: false,
      escola: localStorage.getItem('escola')
        ? localStorage.getItem('escola')
        : '',
      table_load: false,
      turmasLoaded: false,
      disciplinasLoaded: false,
      pagination: {
        current_page: 1,
        per_page: 0,
        total: 0
      },
      data_enable: false
    }
  },
  watch: {
    filters: {
      deep: true,
      /* eslint-disable */
      handler() {
        clearTimeout(this.delay)
        this.delay = setTimeout(() => this.load(), 750)
      }
    },
    options: {
      deep: true,
      handler() {
        clearTimeout(this.delay)
        this.delay = setTimeout(() => this.load(), 750)
      }
    }
  },
  async created() {
    this.turmas = await Turma.findAll({
      escola: this.escola,
      ano: this.filters.ano
    })
    // this.disciplinasLoaded = this.disciplinas.length > 0
    this.turmasLoaded = this.turmas.length > 0
    this.load()
  },
  methods: {
    async load() {
      this.table_load = true
      if (this.turmasLoaded) {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        this.cardapios = await Cardapio.filter({
          ...this.filters,
          pagesize: this.options.itemsPerPage,
          page: this.options.page,
          order: this.options.sortBy ? this.options.sortBy[0] : '',
          dir: this.options.sortDesc == true ? 'DESC' : 'ASC',
          escola: this.escola
        })
        this.pagination.total = this.cardapios.total
        this.pagination.current_page = this.cardapios.current_page
        this.pagination.per_page = parseInt(this.cardapios.per_page)
      }
      this.table_load = false
    },
    turmas_format(turma) {
      return `${turma.serie.nome} - ${turma.nome} - ${turma.serie.nivel.nome}`
    },
    async remove(id) {
      await Cardapio.delete(id, { escola: this.escola })
      this.load()
    },
    limpar() {
      this.filters = {}
    }
  }
}
</script>

<style scoped>
</style>
